/**
 * Cost - Represents cost information for pay items.
 * Used to track estimated prices, unit prices, and calculated item costs.
 */
export class Cost {
  /** Type of estimate (e.g., "Engineer", "Contractor", "Historical") */
  EstimateType: string;

  /** Engineer's estimated price */
  EngEstPrice: number;

  /** Override value for cost calculation */
  Override: number;

  /** Factor used in cost calculation */
  Factor: number;

  /** Unit price for the item */
  UnitPrice: number;

  /** Final calculated item cost */
  ItemCost: number;

  /**
   * Creates a new Cost instance
   * @param data - Object containing cost properties
   */
  constructor(data: {
    EstimateType: string;
    EngEstPrice: number;
    Override: number;
    Factor: number;
    UnitPrice: number;
    ItemCost: number;
  }) {
    this.EstimateType = data.EstimateType;
    this.EngEstPrice = data.EngEstPrice;
    this.Override = data.Override;
    this.Factor = data.Factor;
    this.UnitPrice = data.UnitPrice;
    this.ItemCost = data.ItemCost;
  }

  /**
   * Creates a Cost from a plain object (useful for deserialization)
   * @param obj - Plain object with cost data
   * @returns New Cost instance
   */
  static fromObject(obj: Partial<Cost>): Cost {
    return new Cost({
      EstimateType: obj.EstimateType ?? "",
      EngEstPrice: obj.EngEstPrice ?? 0,
      Override: obj.Override ?? 0,
      Factor: obj.Factor ?? 0,
      UnitPrice: obj.UnitPrice ?? 0,
      ItemCost: obj.ItemCost ?? 0,
    });
  }

  /**
   * Converts the Cost to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      EstimateType: this.EstimateType,
      EngEstPrice: this.EngEstPrice,
      Override: this.Override,
      Factor: this.Factor,
      UnitPrice: this.UnitPrice,
      ItemCost: this.ItemCost,
    };
  }
}


